/**
 * @Author: v_jppjpeng
 * @Date: 2023-05-23 19:50:02
 * @Explain: 登录、注册、忘记密码
 */

export default {
  // 登录公告
  'ADMIN.ANNOUNCEMENT.TITLE': '公告',
  'ADMIN.ANNOUNCEMENT.TIPS1': '用户数据存储位置将更改为GCP德国。',
  'ADMIN.ANNOUNCEMENT.TIPS2':
    '用户数据迁移预计于2024年3月完成。用户数据将从腾讯云新加坡迁移至谷歌云德国平台。',
  'ADMIN.ANNOUNCEMENT.TIPS3': '更新后的隐私政策可在下面找到。',
  'ADMIN.ANNOUNCEMENT.TIPS4':
    '如果您不同意按照隐私政策所述的方式处理您的个人信息，请停止使用 SmartLink。',
  'ADMIN.ANNOUNCEMENT.TIPS5':
    '继续使用 SmartLink，即表示您承认我们有关以下方面的规则：按照本隐私政策所述记录您的个人信息。',
  'ADMIN.ANNOUNCEMENT.PRIVACY.POLICY': '隐私政策',
  'ADMIN.ANNOUNCEMENT.PRIVACY.POLICY.LAST.UPDATED':
    '最后更新时间：2024 年 2 月 22 日',
  'ADMIN.ANNOUNCEMENT.OK': '确认',

  // 登录
  'ADMIN.LOGIN.TITLE': '登录SmartLink',
  'ADMIN.LOGIN.NEED.ACCOUNT': '是否需要SmartLink账号？',
  'ADMIN.LOGIN.CREATE.ACCOUNT': '创建账号',
  'ADMIN.LOGIN.USERNAME.EMAIL': '用户名或邮箱',
  'ADMIN.LOGIN.PLEASE.ENTER.USERNAME.EMAIL': '请输入用户名或邮箱',
  'ADMIN.LOGIN.PASSWORD': '密码',
  'ADMIN.LOGIN.PASSWORD.CHECK1': '至少包含一个小写字符',
  'ADMIN.LOGIN.PASSWORD.CHECK2': '至少包含一个大写字符',
  'ADMIN.LOGIN.PASSWORD.CHECK3': '至少包含一个数字',
  'ADMIN.LOGIN.PASSWORD.CHECK4': '至少包含一个特殊字符',
  'ADMIN.LOGIN.PASSWORD.CHECK5': '最少输入8个字符',
  'ADMIN.LOGIN.PLEASE.ENTER.PASSWORD': '请输入密码',
  'ADMIN.LOGIN.NOT.EMAIL.PASSWORD': '您未输入用户名或密码',
  'ADMIN.LOGIN.PLEASE.ENTER.PASSWORD.REG':
    '请输入密码，其中包含至少一个大写字母、一个小写字母、一个数字和一个特殊字符，最少输入8个字符',
  'ADMIN.LOGIN.RE.PASSWORD': '确认密码',
  'ADMIN.LOGIN.PASSWORD.INCONSISTENCY': '两次密码不一致.请重新输入',
  'ADMIN.LOGIN.PLEASE.CHECK.VERIFICATION.CODE': '请勾选验证码',
  'ADMIN.LOGIN.GET.SIGN.FAIL': '获取签名有误',
  'ADMIN.LOGIN.FORGOT.PASSWORD': '忘记密码？',
  'ADMIN.LOGIN.BTN': '登录',
  'ADMIN.LOGIN.OR': '或',
  'ADMIN.LOGIN.IOA.BTN': '使用腾讯的OA账号登录',
  'ADMIN.LOGIN.SUCCESS': '登录成功',
  'ADMIN.LOGIN.FAIL.TRY': '登录失败，请刷新页面后重试',

  // 登录 - 长时间未操作状态
  'ADMIN.LOGIN.SESSION.TITLE': '您的SmartLink登录态已过期',
  'ADMIN.LOGIN.SESSION.SMALL': '如需回到上次的页面，请输入密码',
  'ADMIN.LOGIN.RESUME.SESSION': '恢复SmartLink页面',
  'ADMIN.LOGIN.SESSION.PASSWORD.ERROR.TIPS1':
    '抱歉，密码不正确。我们可以帮助您',
  'ADMIN.LOGIN.SESSION.PASSWORD.ERROR.TIPS2': '恢复您的密码',

  // 注册
  'ADMIN.REGISTER.TITLE': '注册 SmartLink',
  'ADMIN.REGISTER.CREATE.ACCOUNT': '使用电子邮件创建一个 SmartLink 账号',
  'ADMIN.REGISTER.CREATE.TIPS1': '1. 验证您的电子邮件',
  'ADMIN.REGISTER.CREATE.TIPS2': '2. 设置您的用户名和密码',
  'ADMIN.REGISTER.EMAIL': '邮箱',
  'ADMIN.REGISTER.EMAIL.DEFAULT.MESSAGE': '请使用邮箱创建SmartLink账号',
  'ADMIN.REGISTER.PLEASE.ENTER.EMAIL': '请输入邮箱地址',
  'ADMIN.REGISTER.PLEASE.ENTER.EMAIL.REG': '请输入正确的邮箱地址',
  'ADMIN.REGISTER.VERIFICATION.CODE': '验证码',
  'ADMIN.REGISTER.PLEASE.ENTER.VERIFICATION.CODE': '请输入验证码',
  'ADMIN.REGISTER.PLEASE.ENTER.PASSWORD.REG': '请输入正确的密码',
  'ADMIN.REGISTER.SUCCESS': '注册成功',
  'ADMIN.REGISTER.USER.NAME': '用户名',
  'ADMIN.REGISTER.PLEASE.ENTER.USER.NAME': '请输入用户名',
  'ADMIN.REGISTER.PLEASE.ENTER.USER.NAME.REG':
    '支持字母、数字、下划线等特殊字符，不支持空格，字母区分大小写',
  'ADMIN.REGISTER.ENTER.USER.NAME.ALREADY.EXIST': '用户名已存在',
  'ADMIN.REGISTER.AGREEMENT.SELECT': '请先勾选同意协议',
  'ADMIN.REGISTER.AGREEMENT.TIPS1':
    '我同意将我的数据传输到我所在的国家/地区之外。',
  'ADMIN.REGISTER.AGREEMENT.TIPS2':
    'SmartLink 是由 Proxima Beta Pte. Ltd.提供的产品，我们是一家在新加坡注册成立的公司，会在您所在的国家/地区之外处理您的数据，用于我们<a href="{ppLink}" target="_blank">隐私政策</a>所述之用途。请注意，此类传输存在风险，包括您的数据可能会因各地法律不同，受到的保护与在您所在的国家/地区不同。如果您希望撤销同意，可以发送邮件至<a href="mailto:{email}">{email}</a>联系我们。',
  'ADMIN.REGISTER.AGREEMENT.TIPS3':
    '我确认我已阅读并知悉<a href="{ppLink}" target="_blank">《隐私政策》</a>及同意<a href="{dpaLink}" target="_blank">《数据处理协议》</a>和<a href="{staLink}" target="_blank">《服务条款》</a>。',

  // 忘记密码
  'ADMIN.FORGOT.PW.TITLE': '重置您的密码',
  'ADMIN.FORGOT.PW.CREATE.TIPS1': '1.验证您的邮箱地址',
  'ADMIN.FORGOT.PW.CREATE.TIPS2': '2.请设置您的新密码',
  'ADMIN.FORGOT.PW.EMAIL': '邮箱地址',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.EMAIL': '请输入邮箱地址',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.EMAIL.REG': '请输入正确的邮箱地址',
  'ADMIN.FORGOT.PW.VERIFICATION.CODE': '验证码',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.VERIFICATION.CODE': '请输入验证码',
  'ADMIN.FORGOT.PW.NEW.PASSWORD': '新密码',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.NEW.PASSWORD': '请输入新密码',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.NEW.PASSWORD.REG': '请输入正确的密码格式',
  'ADMIN.FORGOT.PW.RE.NEW.PASSWORD': '再次输入新密码',
  'ADMIN.FORGOT.PW.PLEASE.ENTER.RE.NEW.PASSWORD': '请再次输入新密码',
  'ADMIN.FORGOT.PW.DIFFERENT': '两次输入的密码不一致',
  'ADMIN.FORGOT.PW.SUCCESS.TIPS': '您已经成功重置了密码',
  'ADMIN.FORGOT.PW.SUCCESS.BTN': '使用新密码登录',

  // 弹窗 - 选择加入项目
  'ADMIN.INVITE.JOIN.PROJECT.TITLE': '您受邀加入SmartLink项目',
  'ADMIN.INVITE.JOIN.PROJECT.SMALL':
    '<b>{inviter}</b> 请求您以 <div class="tag">{roleName}</div> 的身份加入项目 <div class="tag">{projectName}</div>',
  'ADMIN.INVITE.JOIN.PROJECT.ROLE.TITLE': 'SmartLink角色描述',
  'ADMIN.INVITE.JOIN.PROJECT.YOU': '你的角色',
  'ADMIN.INVITE.JOIN.PROJECT.BTN': '加入项目',
  'ADMIN.INVITE.JOIN.PROJECT.SUCCESS': '成功加入项目',

  'ADMIN.CHOOSE.PROJECT.TITLE': '选择进入项目的方式',
  'ADMIN.JOIN.PROJECT.TITLE': '加入现有项目',
  'ADMIN.JOIN.PROJECT.DESC':
    '这要求您的合作伙伴在SmartLink内先创建项目，并请您告知项目的 超级管理员/普通管理员 在SmartLink项目中邀请您加入。',
  'ADMIN.CREATE.PROJECT.TITLE': '创建一个新项目',
  'ADMIN.CREATE.PROJECT.DESC':
    '作为项目的超级管理员，您可以创建一个新项目，并邀请您的合作伙伴在SmartLink中共同工作。',
  'ADMIN.DEMO.PROJECT.TITLE': '体验Demo项目',
  'ADMIN.DEMO.PROJECT.DESC':
    '在进入真正的项目之前，您可以在Demo项目中体验SmartLink的大部分功能。',

  // 欢迎页 - 进入demo提示
  'ADMIN.DEMO.PROJECT.MODAL.TITLE': 'Demo项目须知',
  'ADMIN.DEMO.PROJECT.MODAL.TIPS1':
    'Demo项目提供功能体验。目前不支持在Demo项目中编写数据，例如保存新数据、删除现有数据等操作。',
  'ADMIN.DEMO.PROJECT.MODAL.TIPS2':
    '所有项目中的数据都是人工制造的虚假数据，因此无法向其发送邮件。',
  'ADMIN.DEMO.PROJECT.MODAL.BTN': '了解',

  // 欢迎页 - 请加入项目
  'ADMIN.WELCOME.HELLO': '你好，{accountName}',
  'ADMIN.WELCOME.SPEECH':
    '您已经成功创建了您的<span class="color-primary">SmartLink账户</span>！',

  //   无权限页面
  'ADMIN.NO.AUTH.TITLE': '没有权限',
  'ADMIN.NO.AUTH.CONTENT.1':
    '未选择项目，请到“<span class="mark">我的项目</span>”中选择要进入的项目',
  'ADMIN.NO.AUTH.CONTENT.2':
    '如需项目权限，请联系项目管理员加入项目 或 创建新项目',
  'ADMIN.NO.AUTH.CREATE.PROJECT': '创建新项目',
  'ADMIN.NO.AUTH.OWN.PROJECT': '我的项目',
};
